import { render, staticRenderFns } from "./RoteirizacaoMotoristasPanel.vue?vue&type=template&id=36955f88&scoped=true&"
import script from "./RoteirizacaoMotoristasPanel.vue?vue&type=script&lang=js&"
export * from "./RoteirizacaoMotoristasPanel.vue?vue&type=script&lang=js&"
import style0 from "./RoteirizacaoMotoristasPanel.vue?vue&type=style&index=0&id=36955f88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36955f88",
  null
  
)

export default component.exports